
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/protection/rNumber",
      function () {
        return require("private-next-pages/protection/rNumber.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/protection/rNumber"])
      });
    }
  